(function attachVkSizeEngine(root, factory) {
  'use strict';

  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  root.VkSizeEngine = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function createVkSizeEngine() {
  'use strict';

  var FIT_ALIASES = {
    aansluitend: 'fitted',
    fitted: 'fitted',
    slim: 'fitted',
    normaal: 'regular',
    normal: 'regular',
    regular: 'regular',
    oversized: 'oversized',
    ruim: 'oversized'
  };

  var DEFAULT_PROFILES = [
    {
      key: 'tshirt',
      label: 'T-shirt',
      productTypeLabel: 'T-shirt',
      optionNames: ['Maat', 'Size'],
      absoluteMinEase: 0,
      nearTieMargin: 2,
      lengthModel: { slope: 0.4, offset: 3, tolerance: 3 },
      inputLimits: { height: [140, 220], chest: [70, 160] },
      fitRules: {
        fitted: { label: 'Aansluitend', minEase: 0, targetEase: 5, maxEase: 10 },
        regular: { label: 'Normaal', minEase: 6, targetEase: 11, maxEase: 16 },
        oversized: { label: 'Oversized', minEase: 14, targetEase: 20, maxEase: 26 }
      },
      sizes: [
        { label: 'S', aliases: ['S'], halfChest: 46, length: 71 },
        { label: 'M', aliases: ['M'], halfChest: 51, length: 74 },
        { label: 'L', aliases: ['L'], halfChest: 56, length: 76 },
        { label: 'XL', aliases: ['XL'], halfChest: 61, length: 79 },
        { label: '2XL', aliases: ['2XL', 'XXL', '2X'], halfChest: 66, length: 81 }
      ]
    },
    {
      key: 'sweater',
      label: 'Trui',
      productTypeLabel: 'Trui',
      optionNames: ['Maat', 'Size'],
      absoluteMinEase: 4,
      nearTieMargin: 2,
      lengthModel: { slope: 0.35, offset: 9.5, tolerance: 3 },
      inputLimits: { height: [140, 220], chest: [70, 160] },
      fitRules: {
        fitted: { label: 'Aansluitend', minEase: 6, targetEase: 11, maxEase: 16 },
        regular: { label: 'Normaal', minEase: 14, targetEase: 19, maxEase: 24 },
        oversized: { label: 'Oversized', minEase: 22, targetEase: 28, maxEase: 34 }
      },
      sizes: [
        { label: 'S', aliases: ['S'], halfChest: 51, length: 69, sleeve: 85 },
        { label: 'M', aliases: ['M'], halfChest: 56, length: 71, sleeve: 88 },
        { label: 'L', aliases: ['L'], halfChest: 61, length: 74, sleeve: 90 },
        { label: 'XL', aliases: ['XL'], halfChest: 66, length: 76, sleeve: 93 },
        { label: '2XL', aliases: ['2XL', 'XXL', '2X'], halfChest: 71, length: 79, sleeve: 95 }
      ]
    },
    {
      key: 'hoodie',
      label: 'Hoodie',
      productTypeLabel: 'Hoodie',
      optionNames: ['Maat', 'Size'],
      absoluteMinEase: 4,
      nearTieMargin: 2,
      lengthModel: { slope: 0.35, offset: 9.5, tolerance: 3 },
      inputLimits: { height: [140, 220], chest: [70, 160] },
      fitRules: {
        fitted: { label: 'Aansluitend', minEase: 6, targetEase: 11, maxEase: 16 },
        regular: { label: 'Normaal', minEase: 14, targetEase: 19, maxEase: 24 },
        oversized: { label: 'Oversized', minEase: 22, targetEase: 28, maxEase: 34 }
      },
      sizes: [
        { label: 'S', aliases: ['S'], halfChest: 51, length: 69, sleeve: 85 },
        { label: 'M', aliases: ['M'], halfChest: 56, length: 71, sleeve: 88 },
        { label: 'L', aliases: ['L'], halfChest: 61, length: 74, sleeve: 90 },
        { label: 'XL', aliases: ['XL'], halfChest: 66, length: 76, sleeve: 93 },
        { label: '2XL', aliases: ['2XL', 'XXL', '2X'], halfChest: 71, length: 79, sleeve: 95 }
      ]
    }
  ];

  function parseLocaleNumber(value) {
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : NaN;
    }

    if (typeof value !== 'string') {
      return NaN;
    }

    var normalized = value.trim().replace(/\s+/g, '').replace(',', '.');
    if (!/^-?\d+(?:\.\d+)?$/.test(normalized)) {
      return NaN;
    }

    return Number(normalized);
  }

  function toFiniteNumber(value, fallback) {
    var parsed = parseLocaleNumber(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function normalizeSizeLabel(value) {
    var label = String(value == null ? '' : value)
      .trim()
      .toUpperCase()
      .replace(/[\s_-]+/g, '');

    var aliases = {
      '2X': '2XL',
      'XXL': '2XL',
      '2XLRG': '2XL',
      '3X': '3XL',
      'XXXL': '3XL'
    };

    return aliases[label] || label;
  }

  function normalizeFit(value) {
    var key = String(value == null ? '' : value).trim().toLowerCase();
    return FIT_ALIASES[key] || key;
  }

  function normalizeAliases(label, aliases) {
    var values = [label].concat(Array.isArray(aliases) ? aliases : []);
    var seen = Object.create(null);

    return values.filter(function uniqueAlias(value) {
      var normalized = normalizeSizeLabel(value);
      if (!normalized || seen[normalized]) {
        return false;
      }
      seen[normalized] = true;
      return true;
    });
  }

  function normalizeProfile(rawProfile) {
    if (!rawProfile || !Array.isArray(rawProfile.sizes)) {
      return null;
    }

    var sizes = rawProfile.sizes.map(function normalizeSize(row, index) {
      if (!row || !row.label) {
        return null;
      }

      var halfChest = toFiniteNumber(row.halfChest, NaN);
      var length = toFiniteNumber(row.length, NaN);
      if (!Number.isFinite(halfChest) || !Number.isFinite(length)) {
        return null;
      }

      return {
        index: index,
        label: String(row.label).trim(),
        aliases: normalizeAliases(row.label, row.aliases),
        halfChest: halfChest,
        garmentChest: halfChest * 2,
        length: length,
        sleeve: Number.isFinite(toFiniteNumber(row.sleeve, NaN))
          ? toFiniteNumber(row.sleeve, NaN)
          : null
      };
    }).filter(Boolean);

    if (!sizes.length) {
      return null;
    }

    var rawLengthModel = rawProfile.lengthModel || {};
    var rawLimits = rawProfile.inputLimits || {};
    var fitRules = {};

    ['fitted', 'regular', 'oversized'].forEach(function normalizeRule(fitKey) {
      var rule = rawProfile.fitRules && rawProfile.fitRules[fitKey];
      if (!rule) {
        return;
      }

      var minEase = toFiniteNumber(rule.minEase, NaN);
      var targetEase = toFiniteNumber(rule.targetEase, NaN);
      var maxEase = toFiniteNumber(rule.maxEase, NaN);
      if (!Number.isFinite(minEase) || !Number.isFinite(targetEase) || !Number.isFinite(maxEase)) {
        return;
      }
      if (minEase > targetEase || targetEase > maxEase) {
        return;
      }

      fitRules[fitKey] = {
        label: String(rule.label || fitKey),
        minEase: minEase,
        targetEase: targetEase,
        maxEase: maxEase
      };
    });

    return {
      key: String(rawProfile.key || rawProfile.label || 'profile').trim(),
      label: String(rawProfile.label || rawProfile.productTypeLabel || 'Kledingstuk').trim(),
      productTypeLabel: String(rawProfile.productTypeLabel || rawProfile.label || 'Kledingstuk').trim(),
      optionNames: Array.isArray(rawProfile.optionNames) && rawProfile.optionNames.length
        ? rawProfile.optionNames.map(String)
        : ['Maat', 'Size'],
      absoluteMinEase: toFiniteNumber(rawProfile.absoluteMinEase, 0),
      nearTieMargin: Math.max(0, toFiniteNumber(rawProfile.nearTieMargin, 2)),
      lengthModel: {
        slope: toFiniteNumber(rawLengthModel.slope, 0),
        offset: toFiniteNumber(rawLengthModel.offset, 0),
        tolerance: Math.max(0, toFiniteNumber(rawLengthModel.tolerance, 3))
      },
      inputLimits: {
        height: Array.isArray(rawLimits.height) ? rawLimits.height.map(Number) : [140, 220],
        chest: Array.isArray(rawLimits.chest) ? rawLimits.chest.map(Number) : [70, 160]
      },
      fitRules: fitRules,
      sizes: sizes
    };
  }

  function rowMatchesSize(row, value) {
    var normalized = normalizeSizeLabel(value);
    return row.aliases.some(function matches(alias) {
      return normalizeSizeLabel(alias) === normalized;
    });
  }

  function buildResult(profile, rule, fit, chest, height, rows) {
    var scored = rows.map(function scoreRow(row) {
      var ease = row.garmentChest - chest;
      return {
        row: row,
        ease: ease,
        chestDistance: Math.abs(ease - rule.targetEase),
        targetLength: profile.lengthModel.slope * height + profile.lengthModel.offset,
        lengthDistance: Math.abs(row.length - (profile.lengthModel.slope * height + profile.lengthModel.offset))
      };
    });

    var pool = scored.filter(function inIdealRange(candidate) {
      return candidate.ease >= rule.minEase && candidate.ease <= rule.maxEase;
    });
    var stage = 'ideal';

    if (!pool.length) {
      pool = scored.filter(function aboveRequestedMinimum(candidate) {
        return candidate.ease >= rule.minEase;
      });
      stage = 'roomier';
    }

    if (!pool.length) {
      pool = scored.filter(function aboveWearableFloor(candidate) {
        return candidate.ease >= profile.absoluteMinEase;
      });
      stage = 'closer';
    }

    if (!pool.length) {
      return {
        ok: false,
        code: 'no_reliable_match',
        message: 'Geen betrouwbare maat binnen dit profiel.'
      };
    }

    var bestChestDistance = Math.min.apply(null, pool.map(function getDistance(candidate) {
      return candidate.chestDistance;
    }));
    var near = pool.filter(function chestEquivalent(candidate) {
      return candidate.chestDistance <= bestChestDistance + profile.nearTieMargin;
    });

    near.sort(function sortCandidates(a, b) {
      if (a.lengthDistance !== b.lengthDistance) {
        return a.lengthDistance - b.lengthDistance;
      }
      if (a.chestDistance !== b.chestDistance) {
        return a.chestDistance - b.chestDistance;
      }
      return fit === 'fitted' ? a.row.index - b.row.index : b.row.index - a.row.index;
    });

    var chosen = near[0];
    var alternate = near.length > 1 ? near[1] : null;
    var lengthDelta = chosen.row.length - chosen.targetLength;
    var lengthAssessment = null;

    if (Math.abs(lengthDelta) > profile.lengthModel.tolerance) {
      lengthAssessment = lengthDelta < 0 ? 'shorter' : 'longer';
    }

    return {
      ok: true,
      code: 'recommendation',
      profileKey: profile.key,
      profileLabel: profile.productTypeLabel,
      fit: fit,
      fitLabel: rule.label,
      label: chosen.row.label,
      row: chosen.row,
      ease: chosen.ease,
      targetEase: rule.targetEase,
      targetLength: chosen.targetLength,
      lengthDelta: lengthDelta,
      lengthAssessment: lengthAssessment,
      stage: stage,
      alternate: alternate ? {
        label: alternate.row.label,
        ease: alternate.ease,
        lengthDelta: alternate.row.length - alternate.targetLength
      } : null
    };
  }

  function validateInputs(profile, height, chest, fit) {
    if (!profile) {
      return { ok: false, code: 'invalid_profile', message: 'Het maatprofiel is niet geldig.' };
    }

    if (!profile.fitRules[fit]) {
      return { ok: false, code: 'invalid_fit', message: 'Kies hoe je het kledingstuk wilt dragen.' };
    }

    if (!Number.isFinite(height)) {
      return { ok: false, code: 'invalid_height', field: 'height', message: 'Vul je lengte in centimeters in.' };
    }

    if (!Number.isFinite(chest)) {
      return { ok: false, code: 'invalid_chest', field: 'chest', message: 'Vul je borstomtrek in centimeters in.' };
    }

    var heightLimits = profile.inputLimits.height;
    var chestLimits = profile.inputLimits.chest;

    if (height < heightLimits[0] || height > heightLimits[1]) {
      return {
        ok: false,
        code: 'height_out_of_range',
        field: 'height',
        message: 'Vul een lengte tussen ' + heightLimits[0] + ' en ' + heightLimits[1] + ' cm in.'
      };
    }

    if (chest < chestLimits[0] || chest > chestLimits[1]) {
      return {
        ok: false,
        code: 'chest_out_of_range',
        field: 'chest',
        message: 'Vul een borstomtrek tussen ' + chestLimits[0] + ' en ' + chestLimits[1] + ' cm in.'
      };
    }

    return { ok: true };
  }

  function recommendSize(options) {
    options = options || {};
    var profile = normalizeProfile(options.profile);
    var height = parseLocaleNumber(options.height);
    var chest = parseLocaleNumber(options.chest);
    var fit = normalizeFit(options.fit);
    var validation = validateInputs(profile, height, chest, fit);

    if (!validation.ok) {
      return validation;
    }

    var ideal = buildResult(profile, profile.fitRules[fit], fit, chest, height, profile.sizes);
    if (!ideal.ok) {
      return ideal;
    }

    if (!Array.isArray(options.availableSizes)) {
      ideal.selectable = true;
      ideal.usedFallback = false;
      ideal.idealLabel = ideal.label;
      return ideal;
    }

    var availableRows = profile.sizes.filter(function isAvailable(row) {
      return options.availableSizes.some(function availableLabel(label) {
        return rowMatchesSize(row, label);
      });
    });
    var idealIsAvailable = availableRows.some(function idealAvailable(row) {
      return row.label === ideal.label;
    });

    if (idealIsAvailable) {
      ideal.selectable = true;
      ideal.usedFallback = false;
      ideal.idealLabel = ideal.label;
      return ideal;
    }

    var fallback = buildResult(profile, profile.fitRules[fit], fit, chest, height, availableRows);
    if (!fallback.ok) {
      ideal.selectable = false;
      ideal.usedFallback = false;
      ideal.idealLabel = ideal.label;
      ideal.unavailable = true;
      return ideal;
    }

    fallback.selectable = true;
    fallback.usedFallback = true;
    fallback.idealLabel = ideal.label;
    fallback.idealResult = ideal;
    return fallback;
  }

  return {
    DEFAULT_PROFILES: DEFAULT_PROFILES,
    normalizeFit: normalizeFit,
    normalizeProfile: normalizeProfile,
    normalizeSizeLabel: normalizeSizeLabel,
    parseLocaleNumber: parseLocaleNumber,
    recommendSize: recommendSize,
    rowMatchesSize: rowMatchesSize
  };
});
